/**
 * Typed environment configuration.
 * All REACT_APP_* variables must be declared here and sourced from .env files.
 */
export const ENV = {
  /** Backend host, e.g. http://localhost:8000 / https://mopsc-as-ecpt-nonprod.mo360cp.i.mercedes-benz.com*/
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8000',
  /** Authentication service host, e.g. http://localhost:8001 / https://mopsc-as-auth-nonprod.mo360cp.i.mercedes-benz.com*/
  AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL ?? 'http://localhost:8001',
  /** Chatbot API base URL, e.g. http://127.0.0.1:8000 */
  CHATBOT_API_URL: process.env.REACT_APP_CHATBOT_API_URL ?? 'http://127.0.0.1:8000',
  /** Chatbot WebSocket URL, e.g. ws://127.0.0.1:8000/ws/chat */
  CHATBOT_WS_URL: process.env.REACT_APP_CHATBOT_WS_URL ?? 'ws://127.0.0.1:8000/ws/chat',
} as const;
